export const COMPONENT_COLOR_LABELS = {
    SYSTEM_AND_CLASS: "Standard",
    MULTIPLACER_COLORS: "IFC-klassefarger",
    MMI: "MMI",
    DISCIPLINE_COLORS: "Fagfarger",
    PRIMARY_SYSTEM: "Primærsystem",
};
